<template>
  <div class="pb-6">
    <field-label :field="field"></field-label>

    <ckeditor
      :editor="editor"
      :value="editorValue"
      :config="editorConfig"
      @input="input"
    ></ckeditor>

    <!-- hidden input used for validation -->
    <div id="hidden-input">
      <v-text-field
        v-model="editorValue"
        :rules="rules"
        hidden
        class="pa-0 ma-0"
      ></v-text-field>
    </div>
  </div>
</template>

<script>
import FieldLabel from '@/components/editor/partials/FieldLabel'
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link'
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import RemoveFormatPlugin from '@ckeditor/ckeditor5-remove-format/src/removeformat'

export default {
  name: 'TextEditorField',
  props: ['value', 'field'],
  components: {
    FieldLabel,
    ckeditor: CKEditor.component
  },
  data: () => ({
    editor: ClassicEditor,
    editorConfig: {
      plugins: [
        EssentialsPlugin,
        BoldPlugin,
        ItalicPlugin,
        LinkPlugin,
        HeadingPlugin,
        ParagraphPlugin,
        RemoveFormatPlugin
      ],
      link: {
        addTargetToExternalLinks: true
      },
      toolbar: {
        shouldNotGroupWhenFull: true,
        items: [
          'heading',
          'bold',
          'italic',
          'link',
          'undo',
          'redo',
          'removeFormat'
        ]
      },
      heading: {
        options: [
          { model: 'paragraph', title: 'Paragraph' },
          {
            model: 'heading1',
            view: 'h1',
            title: 'Heading 1',
            class: 'ck-heading_heading1'
          },
          {
            model: 'heading2',
            view: 'h2',
            title: 'Heading 2',
            class: 'ck-heading_heading2'
          },
          {
            model: 'heading3',
            view: 'h3',
            title: 'Heading 3',
            class: 'ck-heading_heading3'
          },
          {
            model: 'heading4',
            view: 'h4',
            title: 'Heading 4',
            class: 'ck-heading_heading4'
          },
          {
            model: 'heading5',
            view: 'h5',
            title: 'Heading 5',
            class: 'ck-heading_heading5'
          },
          {
            model: 'heading6',
            view: 'h6',
            title: 'Heading 6',
            class: 'ck-heading_heading6'
          }
        ]
      }
    }
  }),
  computed: {
    editorValue() {
      // parse value to prevent "TypeError: Cannot convert undefined or null to object"
      return this.value || ''
    },
    rules() {
      let rules = this.field.rules || []

      return rules.map(rule => this.$store.state.editor.validation.rules[rule])
    }
  },
  methods: {
    input(value) {
      this.$emit('update:value', value)
    },
    setDefaultValue() {
      // TODO - fix default value set up
      // if (this.value === undefined && this.field.default !== undefined) {
      //   this.input(this.field.default)
      // }
    }
  },
  mounted() {
    this.setDefaultValue()
  }
}
</script>

<style>
:root {
  --ck-border-radius: 4px;
  --ck-color-base-border: rgba(0, 0, 0, 0.42);
  --ck-focus-ring: 1px solid #45a3d6;
  --ck-inner-shadow: 0;
}
#hidden-input {
  height: 0;
}
#hidden-input .v-text-field > .v-input__control > .v-input__slot:before {
  border: none !important;
}

.ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: var(--ck-border-radius);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.ck.ck-sticky-panel__content,
.ck.ck-toolbar.ck-toolbar_grouping {
  background-color: transparent !important;
}
</style>
